/* =========================================================================
   CHARMANTE — Couche dynamique (premium)
   Barre de progression · header réactif · parallax hero · tilt 3D ·
   boutons magnétiques · projectile discret vers le panier.
   Défensif : ne casse rien si un élément est absent. Respecte
   prefers-reduced-motion (désactive le mouvement « décoratif »).
   ========================================================================= */
(function () {
  'use strict';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const COLORS = ['#ff78a0', '#ff8b42', '#e60837', '#ffd3df', '#ffd23f', '#82040d'];
  const onIdle = (fn) => (window.requestIdleCallback || requestAnimationFrame)(fn);

  /* ----------------------------------------------------------------------
     1) Barre de progression de lecture
  ---------------------------------------------------------------------- */
  (function scrollProgress() {
    const bar = document.createElement('div');
    bar.className = 'scrollbar';
    const fill = document.createElement('div');
    fill.className = 'scrollbar__fill';
    bar.appendChild(fill);
    document.body.appendChild(bar);

    let ticking = false;
    function update() {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const pct = max > 0 ? (h.scrollTop / max) * 100 : 0;
      fill.style.width = pct.toFixed(2) + '%';
      ticking = false;
    }
    addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();

  /* ----------------------------------------------------------------------
     2) Header : ombre quand on défile, et reste TOUJOURS visible (sticky)
  ---------------------------------------------------------------------- */
  (function smartHeader() {
    const header = document.querySelector('.header');
    if (!header) return;
    let ticking = false;
    function update() {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      header.classList.remove('is-hidden');   // l'en-tête suit toujours le défilement, il ne se replie plus
      ticking = false;
    }
    addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();

  /* ----------------------------------------------------------------------
     3) Parallax du hero (média + contenu)
  ---------------------------------------------------------------------- */
  (function heroParallax() {
    if (reduce) return;
    const hero = document.querySelector('.hero');
    if (!hero) return;
    const media = hero.querySelector('.hero__media');
    const content = hero.querySelector('.hero__content');
    const deco = hero.querySelector('.hero__deco');
    let ticking = false;
    function update() {
      const y = window.scrollY;
      if (y < window.innerHeight) {
        if (media) media.style.transform = `translate3d(0, ${y * 0.28}px, 0) scale(1.05)`;
        if (content) { content.style.transform = `translate3d(0, ${y * 0.12}px, 0)`; content.style.opacity = String(Math.max(0, 1 - y / (window.innerHeight * 0.8))); }
        if (deco) deco.style.transform = `translate3d(0, ${y * -0.06}px, 0)`;
      }
      ticking = false;
    }
    addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();

  /* ----------------------------------------------------------------------
     4) (Effet magnétique des boutons retiré — survol plus calme et fluide,
        géré uniquement en CSS.)
  ---------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------
     5) Tilt 3D sur les cartes (catégories, produits, bases perso)
  ---------------------------------------------------------------------- */
  (function tiltCards() {
    if (reduce || matchMedia('(hover: none)').matches) return;
    const MAX = 7; // degrés (inclinaison max — effet plus doux)
    function bind(card) {
      if (card.dataset.tilt) return; card.dataset.tilt = '1';
      if (card.closest('[data-no-tilt]')) return; // cartes en carrousel : pas de tilt 3D (plus doux)
      // Cible du tilt : si la carte a une couche fond .cat-card__media (cartes photo),
      // on pivote/zoome CETTE couche — la carte (non pivotée) garde un découpage arrondi
      // 2D stable, donc plus jamais de coins carrés. Sinon, on pivote la carte elle-même.
      const media = card.querySelector('.cat-card__media') || card.querySelector('.prodcard__stack');
      const target = media || card;
      const glare = document.createElement('span');
      glare.className = 'tilt-glare';
      card.appendChild(glare);
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width;
        const py = (e.clientY - r.top) / r.height;
        const rx = (0.5 - py) * (MAX * 2);
        const ry = (px - 0.5) * (MAX * 2);
        // couche photo : tilt + léger zoom ; carte directe : tilt + soulèvement (comme avant)
        const extra = media ? ' scale(1.05)' : ' translateY(-6px) scale(1.03)';
        target.style.transform = `perspective(620px) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg)${extra}`;
        glare.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        glare.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        glare.style.opacity = '1';
      });
      card.addEventListener('pointerleave', () => { target.style.transform = ''; glare.style.opacity = '0'; });
    }
    function scan() { document.querySelectorAll('.cat-card, .product, .perso-card, .bs-grid .prodcard').forEach(bind); }
    scan();
    // Les produits sont injectés après coup → on rescanne brièvement.
    let tries = 0;
    const iv = setInterval(() => { scan(); if (++tries > 8) clearInterval(iv); }, 250);
  })();

  /* ----------------------------------------------------------------------
     6) Projectile discret vers l'icône panier (ajout au panier)
  ---------------------------------------------------------------------- */
  function cartIcon() {
    const badge = document.querySelector('[data-cart-count]');
    return badge ? badge.closest('.iconbtn') : document.querySelector('.header__right .iconbtn:last-child');
  }

  function flyToCart(fromEl) {
    if (reduce) return;
    const target = cartIcon();
    if (!target || !fromEl) return;
    const s = fromEl.getBoundingClientRect();
    const t = target.getBoundingClientRect();
    for (let i = 0; i < 3; i++) {
      const h = document.createElement('div');
      h.textContent = '♥';
      h.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;font-size:20px;line-height:1;will-change:transform,opacity;';
      h.style.color = COLORS[Math.floor(Math.random() * 3)];
      h.style.left = (s.left + s.width / 2 - 10) + 'px';
      h.style.top = (s.top + s.height / 2 - 10) + 'px';
      document.body.appendChild(h);
      const jitter = (Math.random() - 0.5) * 46;
      const dx = (t.left + t.width / 2) - (s.left + s.width / 2) + jitter;
      const dy = (t.top + t.height / 2) - (s.top + s.height / 2);
      (function (el, ex, ey, delay) {
        setTimeout(function () {
          requestAnimationFrame(function () {
            el.style.transition = 'transform .85s cubic-bezier(.5,-0.2,.35,1), opacity .85s ease';
            el.style.transform = 'translate(' + ex + 'px,' + ey + 'px) scale(.4)';
            el.style.opacity = '0';
          });
          setTimeout(function () { el.remove(); }, 900);
        }, delay);
      })(h, dx, dy, i * 90);
    }
  }

  // Badge qui rebondit dès qu'il change de valeur
  (function watchBadge() {
    const badge = document.querySelector('[data-cart-count]');
    if (!badge) return;
    const mo = new MutationObserver(() => {
      badge.classList.remove('bump');
      void badge.offsetWidth; // reflow pour rejouer l'animation
      badge.classList.add('bump');
    });
    mo.observe(badge, { childList: true, characterData: true, subtree: true });
  })();

  // Déclenche le projectile discret au clic sur un bouton d'ajout
  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-add], #czAdd');
    if (!add) return;
    flyToCart(add);
  }, true);

  /* ----------------------------------------------------------------------
     7) Auras décoratives douces dans les sections claires
  ---------------------------------------------------------------------- */
  onIdle(function auras() {
    if (reduce) return;
    document.querySelectorAll('.section--sable').forEach((sec, i) => {
      const a = document.createElement('span');
      a.className = 'aura ' + (i % 2 ? 'aura--corail' : 'aura--rose');
      a.style.width = a.style.height = 'clamp(220px, 36vw, 460px)';
      a.style[i % 2 ? 'right' : 'left'] = '-8%';
      a.style.top = i % 2 ? 'auto' : '-6%';
      a.style.bottom = i % 2 ? '-10%' : 'auto';
      sec.prepend(a);
    });
  });

  /* ----------------------------------------------------------------------
     8) Stickers flottants — parallax multi-couches (scroll + souris)
        On utilise la propriété CSS `translate` (indépendante de `transform`)
        pour composer avec l'animation de flottement `floatBob`.
  ---------------------------------------------------------------------- */
  (function floatingStickers() {
    if (reduce) return;
    const floats = Array.from(document.querySelectorAll('[data-parallax]'));
    if (!floats.length) return;
    const hero = document.querySelector('.hero') || document;
    let mx = 0, my = 0, sy = window.scrollY, ticking = false;

    function apply() {
      floats.forEach((f) => {
        const p = parseFloat(f.dataset.parallax) || 0;  // profondeur au scroll
        const t = parseFloat(f.dataset.tilt) || 0;       // profondeur à la souris (px)
        const dx = mx * t;
        const dy = my * t - sy * p;
        f.style.translate = dx.toFixed(1) + 'px ' + dy.toFixed(1) + 'px';
      });
      ticking = false;
    }
    if (!matchMedia('(hover: none)').matches) {
      hero.addEventListener('pointermove', (e) => {
        mx = (e.clientX / window.innerWidth) - 0.5;
        my = (e.clientY / window.innerHeight) - 0.5;
        if (!ticking) { ticking = true; requestAnimationFrame(apply); }
      });
    }
    window.addEventListener('scroll', () => {
      sy = window.scrollY;
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  })();

  /* ----------------------------------------------------------------------
     9) Ajout au panier en AJAX (cœurs qui volent + sans rechargement)
        + inscription newsletter sans saut de page
  ---------------------------------------------------------------------- */
  function czToast(msg) {
    var el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);background:var(--bordeaux,#82040d);color:#fff;padding:12px 20px;border-radius:999px;font-weight:600;z-index:10000;opacity:0;transition:opacity .25s ease,transform .25s ease;box-shadow:0 10px 30px rgba(0,0,0,.18);max-width:90vw;text-align:center;';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.style.opacity = '1'; el.style.transform = 'translateX(-50%) translateY(0)'; });
    setTimeout(function () { el.style.opacity = '0'; el.style.transform = 'translateX(-50%) translateY(20px)'; setTimeout(function () { el.remove(); }, 320); }, 2200);
  }

  // On partage l'animation cœur + le toast pour le panier AJAX (charmante-cart.js)
  window.Charmante = window.Charmante || {};
  window.Charmante.flyToCart = flyToCart;
  window.Charmante.toast = czToast;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.newsletter__form');
    if (!form) return;
    e.preventDefault();
    var email = form.querySelector('input[type="email"]');
    if (email && !email.checkValidity()) { email.reportValidity(); return; }
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(form.action.split('#')[0], { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
      .then(function () {
        form.innerHTML = '<p class="field-help" style="color:var(--rouge);font-weight:600">Merci&nbsp;! Surveille ta boîte mail 🐚</p>';
      })
      .catch(function () { if (btn) btn.disabled = false; czToast('Oups, réessaie 🙈'); });
  });
})();
